/* AMAVYA - couche de signature. Aucune bibliotheque, aucun appel reseau. */
(function () {
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pointeurFin = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Quand les transitions de page sont actives, Horizon deplace le defilement
     de la fenetre vers .page-wrapper. On lit donc le defileur reel, sans le
     supposer. */
  function defileur() {
    var w = document.querySelector('.page-wrapper');
    if (w && w.scrollHeight > w.clientHeight + 1) return w;
    return null;
  }

  /* 1. Arrivee des sections au defilement.
        La classe qui masque est posee ici, par le script : si le JavaScript ne
        s'execute pas, la page reste entierement visible. */
  var observateur = null;

  if (!reduit && 'IntersectionObserver' in window) {
    observateur = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        if (entrees[i].isIntersecting) {
          entrees[i].target.classList.add('is-in');
          observateur.unobserve(entrees[i].target);
        }
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  }

  function marquer() {
    if (!observateur) return;

    var cibles = document.querySelectorAll('#MainContent .shopify-section > *');
    for (var i = 0; i < cibles.length; i++) {
      var el = cibles[i];
      if (el.getAttribute('data-amavya-reveal')) continue;
      el.setAttribute('data-amavya-reveal', '1');
      el.classList.add('amavya-reveal');
      observateur.observe(el);
    }

    /* Filet de securite : si l'observateur ne se declenche pas, ce qui est
       deja dans l'ecran redevient visible au bout de deux secondes. */
    window.setTimeout(function () {
      var restants = document.querySelectorAll('.amavya-reveal:not(.is-in)');
      for (var j = 0; j < restants.length; j++) {
        if (restants[j].getBoundingClientRect().top < window.innerHeight) {
          restants[j].classList.add('is-in');
        }
      }
    }, 2000);
  }

  /* 2. La lumiere du bijoutier : le halo suit le pointeur sur l'objet. */
  if (pointeurFin) {
    document.addEventListener('pointermove', function (e) {
      var cible = e.target;
      if (!cible || !cible.closest) return;

      var vitrine = cible.closest('.card-gallery');
      if (!vitrine) return;

      var b = vitrine.getBoundingClientRect();
      if (!b.width || !b.height) return;

      vitrine.style.setProperty('--amavya-x', (((e.clientX - b.left) / b.width) * 100).toFixed(1) + '%');
      vitrine.style.setProperty('--amavya-y', (((e.clientY - b.top) / b.height) * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  /* 3. Le fil de progression de lecture.
        L'ecoute est posee sur le document en phase de capture : les evenements
        de defilement ne remontent pas, mais ils sont bien captes ainsi, quel
        que soit l'element qui defile. */
  if (!reduit && document.body) {
    var fil = document.createElement('div');
    fil.className = 'amavya-progression';
    fil.setAttribute('aria-hidden', 'true');
    document.body.appendChild(fil);

    var enAttente = false;

    var majFil = function () {
      enAttente = false;
      var d = defileur();
      var haut = d ? d.scrollTop : window.scrollY;
      var course = d
        ? d.scrollHeight - d.clientHeight
        : document.documentElement.scrollHeight - window.innerHeight;
      var part = course > 0 ? (haut / course) * 100 : 0;
      fil.style.width = Math.min(100, Math.max(0, part)) + '%';
    };

    document.addEventListener('scroll', function () {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(majFil);
    }, { capture: true, passive: true });

    majFil();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', marquer);
  } else {
    marquer();
  }

  document.addEventListener('shopify:section:load', marquer);
  window.addEventListener('pageshow', marquer);
})();

/* 4. Menu d'en-tete : intention de survol (14/09/2026).
      Horizon change de sous-menu des que le pointeur touche un autre titre de la barre. Pour aller
      en diagonale vers une famille ou une photo, la souris traverse souvent un ou deux titres
      voisins : le menu basculait ou se fermait, et on ne pouvait plus cliquer.
      Regles : on ne change de sous-menu que si le pointeur s'arrete sur le nouveau titre sans
      descendre ; on ne ferme que si le pointeur a quitte toute la barre et le sous-menu ouvert.
      Les methodes activate et deactivate sont relues a chaque evenement par component.js : on les
      enveloppe, sans toucher au code d'Horizon. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var DELAI_CHANGE = 260;
  var DELAI_SORTIE = 320;

  function itemDe(cible) {
    return cible && cible.closest ? cible.closest('.menu-list__list-item') : null;
  }

  function brancher(menu) {
    if (menu.__amavyaIntention || typeof menu.activate !== 'function' || typeof menu.deactivate !== 'function') return;
    menu.__amavyaIntention = true;

    var activer = menu.activate;
    var desactiver = menu.deactivate;
    var minuteChange = null;
    var minuteSortie = null;
    var candidat = null;
    var yDepart = 0;
    var dernierY = 0;

    /* Horizon relance un pointerenter synthetique (sans coordonnees) quand le pointeur s'arrete :
       on garde la derniere hauteur reelle du pointeur pour juger s'il descend. */
    document.addEventListener('pointermove', function (e) { dernierY = e.clientY; }, { passive: true, capture: true });

    function itemOuvert() {
      return itemDe(menu.querySelector('.menu-list__list-item [aria-expanded="true"]'));
    }

    function annulerChange() {
      clearTimeout(minuteChange);
      minuteChange = null;
      candidat = null;
      document.removeEventListener('pointermove', suivre);
    }

    /* Le pointeur descend vers le sous-menu ouvert : ce n'est pas un changement de titre. */
    function suivre(e) {
      if (candidat && e.clientY > yDepart + 3) annulerChange();
    }

    menu.activate = function (event) {
      var li = itemDe(event && event.target);
      var ouvert = itemOuvert();

      if (event && event.type === 'pointerenter' && li && ouvert && ouvert !== li) {
        annulerChange();
        candidat = li;
        yDepart = event.isTrusted ? event.clientY : dernierY;
        document.addEventListener('pointermove', suivre);
        minuteChange = setTimeout(function () {
          var cible = candidat;
          annulerChange();
          if (cible && cible.matches(':hover')) activer.call(menu, { type: 'pointerenter', target: cible });
        }, DELAI_CHANGE);
        return;
      }

      if (li && ouvert === li) {
        annulerChange();
        clearTimeout(minuteSortie);
        minuteSortie = null;
      }
      return activer.call(menu, event);
    };

    menu.deactivate = function (event) {
      var li = itemDe(event && event.target);
      if (event && event.type === 'pointerleave' && li) {
        clearTimeout(minuteSortie);
        minuteSortie = setTimeout(function () {
          minuteSortie = null;
          if (itemOuvert() !== li) return;
          if (li.matches(':hover') || menu.matches(':hover')) return;
          annulerChange();
          desactiver.call(menu, { type: 'pointerleave', target: li, relatedTarget: null });
        }, DELAI_SORTIE);
        return;
      }
      return desactiver.call(menu, event);
    };

    /* Le pointeur quitte la barre sans passer par un pointerleave du titre ouvert. */
    menu.addEventListener('pointerleave', function () {
      var ouvert = itemOuvert();
      if (ouvert) menu.deactivate({ type: 'pointerleave', target: ouvert, relatedTarget: null });
    });
  }

  function brancherTout() {
    var menus = document.querySelectorAll('header-menu');
    for (var i = 0; i < menus.length; i++) brancher(menus[i]);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('header-menu').then(brancherTout);
    document.addEventListener('shopify:section:load', function () {
      customElements.whenDefined('header-menu').then(brancherTout);
    });
  }
})();
